import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import { PagedResponse, QueryFiltersParams, QueryPagingParams, getPagingParams } from 'mbs-ui-shared@models/Paging';
import { BackupHistory, LocalBackupHistoryParams } from 'mbs-ui-shared@models/backupHistory';
import { BackupHistoryService } from 'mbs-ui-shared@services/backup-history';
import { convertLocalBackupHistoryParamsToRemote, prepareLocalBackupHistoryData } from 'mbs-ui-shared@utils/backupHistory';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { BackupHistoryStoreActions, BackupHistoryStoreSelectors } from '.';

@Injectable()
export class BackupHistoryEffects {
  loadPage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BackupHistoryStoreActions.loadPage),
      concatLatestFrom(() => this.store.select(BackupHistoryStoreSelectors.selectPreQueryPagingParams)),
      filter(([, { pagingParams, pageNumbers }]) => !pageNumbers.some((pageIndex) => pageIndex === pagingParams.currentPageNumber)),
      switchMap(([, { filters, pagingParams }]) =>
        this.prepareLocalBackupHistoryEntities({ ...filters, ...getPagingParams(pagingParams) }).pipe(
          map((result) =>
            BackupHistoryStoreActions.loadPageSuccess({
              pageNumber: pagingParams.currentPageNumber,
              entities: result.data,
              total: result.total,
              totalComputers: result.totalComputers
            })
          ),
          catchError(() => of(BackupHistoryStoreActions.loadPageError()))
        )
      )
    );
  });

  constructor(public store: Store, public actions$: Actions, private service: BackupHistoryService, private i18N: I18NextPipe) {}

  private prepareLocalBackupHistoryEntities(
    params: QueryFiltersParams & QueryPagingParams
  ): Observable<PagedResponse<BackupHistory> & { totalComputers?: number }> {
    return this.service
      .get(convertLocalBackupHistoryParamsToRemote(params as unknown as LocalBackupHistoryParams))
      .pipe(map((response) => prepareLocalBackupHistoryData(params, response, this.i18N)));
  }
}
